import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import ProductFilterInside from './ProductFilterInside';



const ProductFilters = memo(( ) => {
	const filterTypesShow = useSelector(state => state.displayProduct.filterTypesShow);

	return (
		<div className={"filters-wrapper"}>
			<div className={"category-filter"}>
				<div className="items">
					{filterTypesShow.map(element => (
						<div key={element.Id} className="item">
							<div className="wrapper">
								<h2>{element.Name}</h2>
								<div className="wrap">
									<ProductFilterInside element={element} />
								</div>
							</div>
						</div>
					)
					)}
				</div>
			</div>
		</div>
	)
})


export default ProductFilters